export default url => fetch(url, { mode: 'cors' })
  .then(response => response.text().then(content => ({ content, response })))
  .then(({ content, response }) => {
    if (!response.ok) {
      return Promise.reject(content);
    }

    return content;
  });
